var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"login login-signin-on bg-color",attrs:{"id":"kt_login"}},[_c('div',{staticClass:"flex-row-fluid d-flex flex-column position-relative"},[_c('div',{staticClass:"view-wrap flex-column-fluid"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }